



































































































































import Vue from 'vue';
import IntegrationCallResourceViewModel from '../../../../services/v1/viewModel/resource/IntegrationCallResourceViewModel';
import IpTableColumn from '../../../../components/p-table/IpTableColumn';
import CompleteIntegrationCallRequestViewModel from '../../../../services/v1/viewModel/resource/CompleteIntegrationCallRequestViewModel';
import GetIntegrationCallStepsByCallIdRequestViewModel from '../../../../services/v1/viewModel/request/IntegrationCalls/GetIntegrationCallStepsByCallIdRequestViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    objectJsonExpanded: false,
    selectedTabIndex: Number as unknown | undefined,
    completeIntegrationCallDialogVisible: false,
    integrationStatusMessage: (undefined as string | undefined),
    requestError: undefined as any,
    columns: [
      { value: Vue.$t('core.page.integrationlog.listDetail.id'), field: 'id' },
      { value: Vue.$t('core.page.integrationlog.listDetail.nr'), field: 'number', textAlign: 'right' },
      { value: Vue.$t('core.page.integrationlog.listDetail.name'), field: 'name' },
      { value: Vue.$t('core.page.integrationlog.listDetail.target'), field: 'targetAppSystemName' },
      { value: Vue.$t('core.page.integrationlog.listDetail.applies'), field: 'isOperative' },
      { value: Vue.$t('core.page.integrationlog.listDetail.success'), field: 'isSuccess' },
      { value: Vue.$t('core.page.integrationlog.listDetail.message'), field: 'message' },
      { value: Vue.$t('core.page.integrationlog.listDetail.processed'), field: 'created', format: (value: string) => Vue.$date(value).format('DD.MM.YYYY HH:mm:ss') },
    ] as IpTableColumn[],
    isLoading: false,
    areStepsLoading: false,
    integrationDetail: {} as IntegrationCallResourceViewModel,
    linkError: (undefined as string | undefined),
    list: {},
    steps: [] as any[],
    id: Number as unknown | undefined,
    integrationCallRunNumbers: [] as any[],
  }),
  computed: {
    integrationObjectString() {
      let integrationObjectString = this.integrationDetail?.integrationObject ?? 'undefined';
      if (integrationObjectString.trim().startsWith('{')) {
        integrationObjectString = JSON.stringify(JSON.parse(integrationObjectString), undefined, 2);
      }
      return integrationObjectString;
    },
    title() {
      return this.integrationDetail.integrationTaskName ?? this.$t('core.page.integrationlog.integrationDetailTitle');
    },
    isHostAdmin() {
      return this.$auth.isInRole('HostAdmin');
    },
    isAdmin() {
      return this.$auth.isInRole('Admin');
    },
  },
  async mounted() {
    this.areStepsLoading = true;
    this.isLoading = true;
    try {
      const { id } = this.$router.currentRoute.params;
      this.id = id;
      const responseIntegrationLog = await this.$service.api.core.integrationCalls.getIntegrationCallById(id as any);
      this.integrationDetail = responseIntegrationLog;
      if (this.integrationDetail.modifierName === null || this.integrationDetail.modifierName === '') {
        this.integrationDetail.modifierName = 'None';
      }
      if (this.integrationDetail.integrationStatusMessage === null || this.integrationDetail.integrationStatusMessage === '') {
        this.integrationDetail.integrationStatusMessage = 'Success';
      }
      const req = new GetIntegrationCallStepsByCallIdRequestViewModel();
      req.runNo = this.integrationDetail.runNo;
      const responseIntegrationSteps = await this.$service.api.core.integrationCalls.getIntegrationCallStepsByCallId(id as any, req);
      this.steps = responseIntegrationSteps.items.map((e : any) => ({ ...e.toDTO() }));
      this.integrationCallRunNumbers = this.integrationCallRuns();
      this.selectedTabIndex = this.integrationDetail.runNo! - 1;
    } catch (error: any) {
      this.linkError = error;
    }
    this.isLoading = false;
    this.areStepsLoading = false;
  },
  methods: {
    back() {
      this.$router.back();
    },
    async completeIntegrationCall() {
      this.isLoading = true;
      try {
        const req = new CompleteIntegrationCallRequestViewModel();
        req.userId = this.$auth.user?.id!;
        req.comment = this.integrationStatusMessage!;
        await this.$service.api.core.integrationCalls.completeIntegrationCall(this.integrationDetail.id!, req);
        this.completeIntegrationCallDialogVisible = false;
        this.integrationDetail = await this.$service.api.core.integrationCalls.getIntegrationCallById(this.integrationDetail.id!);
      } catch (error: any) {
        this.requestError = error;
      }
      this.isLoading = false;
    },
    completeIntegrationCallPopUp() {
      this.completeIntegrationCallDialogVisible = true;
    },
    reExecuteIntegrationCall() {
      this.$router.push(`/_hostadmin/integrationlog/${this.integrationDetail.id}/reExecute`);
    },
    async loadSteps(runNo: number) {
      try {
        const req = new GetIntegrationCallStepsByCallIdRequestViewModel();
        req.runNo = runNo;
        const responseIntegrationSteps = await this.$service.api.core.integrationCalls.getIntegrationCallStepsByCallId(this.integrationDetail.id!, req);
        this.steps = responseIntegrationSteps.items.map((e : any) => ({ ...e.toDTO() }));
      } catch (error: any) {
        this.requestError = error;
      }
    },
    integrationCallRuns() {
      const numbers = [];
      const currentNumber = this.integrationDetail.runNo!;
      for (let i = currentNumber; i! > 0; i -= 1) {
        numbers.push(i);
      }
      return numbers.reverse();
    },
    writeRequestToQuery() {
      if (this.integrationDetail.correlationId != null) {
        this.$routerUtils.updateQueryParams(this.integrationDetail.toQuery(), { preserve: false });
      }
    },
  },
});
